package redmcrosco.alex.farmatch.utils

import kotlinx.browser.window

class JsSettingsStorage : SettingsStorage {
    override fun getString(key: String, default: String): String {
        return window.localStorage.getItem(key) ?: default
    }

    override fun saveString(key: String, value: String) {
        window.localStorage.setItem(key, value)
    }
}

actual fun createSettingsStorage(context: Any?): SettingsStorage {
    return JsSettingsStorage()
}
